<template>
  <div class="mortgage-progress-show-item-component" v-bind:class="{loading}">
    <a-row type="flex">
      <a-col flex="auto">
        <div>
          {{ mortgageProgress.name }}
        </div>

        <div class="small" v-if="false">
          <check-bold-icon class="green" v-if="mortgageProgress.received"/>
          <close-thick-icon class="red" v-else/>
          Opgevraagd bij klant

          <check-bold-icon class="green" v-if="mortgageProgress.sent"/>
          <close-thick-icon class="red" v-else/>
          Verzonden naar maatschappij

          <check-bold-icon class="green" v-if="mortgageProgress.completed"/>
          <close-thick-icon class="red" v-else/>
          Goedgekeurd
        </div>
      </a-col>

      <a-col flex="200px" class="text-right">
        <a-button v-if="canMoveBack"
                  :style="{opacity: (declineItem ? '1.0' : '0.4')}"
                  style="background-color: #ff4d4f"
                  type="danger"
                  @click="handleDeclineToggle"
        >
          <arrow-up-thick-icon v-if="declineItem"/>
          <close-thick-icon v-else/>
        </a-button>

        <a-button type="primary" v-bind:loading="loadingForward" v-if="canMoveForward" v-on:click="moveForward">
          <arrow-down-thick-icon/>
        </a-button>

        <a-tooltip placement="top">
          <template slot="title" v-if="hasComment">
            <span>{{ mortgageProgress.comment }}</span>
          </template>
          <a-button type="default" v-bind:loading="loadingComment" v-on:click.stop="toggleComment">
            <comment-outline-icon v-if="!hasComment"/>
            <comment-text-outline-icon v-else/>
          </a-button>
        </a-tooltip>
      </a-col>
    </a-row>

    <a-row type="flex" v-if="showComment" style="margin-top: 10px">
      <a-col flex="auto">
        <a-textarea
            ref="commentInput"
            placeholder="Notitie"
            v-model="mortgageProgress.comment"
            v-bind:auto-size="{ minRows: 2, maxRows: 6 }"
            v-on:input="onCommentChange"
            v-on:blur="onCommentBlur"
        />
      </a-col>
    </a-row>

  </div>
</template>

<script>
import mortgageProgressApi from '~/api/mortgage_progress'
import debounce from 'lodash/debounce'
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'MortgageProgressShowItemComponent',
  components: {},
  props: {
    mortgageProgress: {
      required: true,
      type: Object
    }
  },
  data () {
    this.onCommentChange = debounce(this.onCommentChange, 1000)

    return {
      value: {},
      deleteConfirmVisible: false,
      loading: false,
      loadingForward: false,
      loadingComment: false,
      showComment: false,
      showCommentModal: false,
      declineItem: false,
    }
  },
  mounted () {},
  computed: {
    ...mapGetters({
      declineSelectionToSendToAgency: "$_mortgage_progress/declineSelectionToSendToAgency",
      declineSelectionToBeApproved: "$_mortgage_progress/declineSelectionToBeApproved",
      declineSelectionApproved: "$_mortgage_progress/declineSelectionApproved",
    }),
    hasComment () {
      return this.mortgageProgress.comment !== null && this.mortgageProgress.comment.length > 0
    },
    canMoveBack () {
      return this.mortgageProgress.received === true
    },
    canMoveForward () {
      return this.mortgageProgress.completed === false
    },
    isToBeApproved () {
      return this.mortgageProgress.received
          && !this.mortgageProgress.sent
          && !this.mortgageProgress.completed
    },
    isToSendToAgency () {
      return this.mortgageProgress.received
          && this.mortgageProgress.sent
          && !this.mortgageProgress.completed
    },
    isApproved () {
      return this.mortgageProgress.received
          && this.mortgageProgress.sent
          && this.mortgageProgress.completed
    },
  },
  methods: {
    ...mapActions({
      addDeclineSelectionToSendToAgency: "$_mortgage_progress/addDeclineSelectionToSendToAgency",
      addDeclineSelectionToBeApproved: "$_mortgage_progress/addDeclineSelectionToBeApproved",
      addDeclineSelectionApproved: "$_mortgage_progress/addDeclineSelectionApproved",

      removeDeclineSelectionToSendToAgency: "$_mortgage_progress/removeDeclineSelectionToSendToAgency",
      removeDeclineSelectionToBeApproved: "$_mortgage_progress/removeDeclineSelectionToBeApproved",
      removeDeclineSelectionApproved: "$_mortgage_progress/removeDeclineSelectionApproved",
    }),
    moveForward () {
      let mortgageProgress = { ...this.mortgageProgress }

      if (mortgageProgress.received === false) {
        mortgageProgress.received = true
      } else if (mortgageProgress.sent === false) {
        mortgageProgress.sent = true
      } else if (mortgageProgress.completed === false) {
        mortgageProgress.completed = true
      }

      this.loading = true
      this.loadingForward = true
      if (this.declineItem) this.removeFromDeclineSelection()

      mortgageProgressApi.update(mortgageProgress)
        .then(() => {
        this.$emit('updated', mortgageProgress)
      }).finally(() => {
        this.loading = false
        this.loadingForward = false
      })
    },
    toggleComment () {
      this.showComment = !this.showComment

      if (this.showComment) {
        this.$nextTick(() => {
          this.$refs.commentInput.focus()
        })
      }
    },
    onCommentChange () {
      this.loading = true
      this.loadingComment = true

      mortgageProgressApi.update(this.mortgageProgress).then(() => {
        this.loading = false
        this.loadingComment = false
        this.$emit('updated', this.mortgageProgress)
      })
    },
    onCommentBlur () {
      this.showComment = false
    },
    handleDeclineToggle () {
      this.declineItem = !this.declineItem;

      this.declineItem ? this.addToDeclineSelection() : this.removeFromDeclineSelection();
    },
    addToDeclineSelection() {
      if (this.isToBeApproved) {
        this.addDeclineSelectionToSendToAgency(this.mortgageProgress);
      }
      else if (this.isToSendToAgency) {
        this.addDeclineSelectionToBeApproved(this.mortgageProgress);
      }
      else if (this.isApproved) {
        this.addDeclineSelectionApproved(this.mortgageProgress);
      }
    },
    removeFromDeclineSelection() {
      if (this.isToBeApproved) {
        this.removeDeclineSelectionToSendToAgency(this.mortgageProgress);
      }
      else if (this.isToSendToAgency) {
        this.removeDeclineSelectionToBeApproved(this.mortgageProgress);
      }
      else if (this.isApproved) {
        this.removeDeclineSelectionApproved(this.mortgageProgress);
      }
    },
  }
}
</script>

<style scoped>
.mortgage-progress-show-item-component {
  padding: 8px 8px 8px 16px;
  border-bottom: 1px solid #e8e8e8;
}

.mortgage-progress-show-item-component:last-child {
  border-bottom: none;
}

.mortgage-progress-show-item-component .delete-button {
  margin: -2px;
}

.mortgage-progress-show-item-component .small {
  color: #333;
}

.mortgage-progress-show-item-component .small .green {
  color: green;
}

.mortgage-progress-show-item-component .small .red {
  color: #870000;
}
</style>
